import { Component, ViewEncapsulation, input } from '@angular/core';


@Component({
    selector: 'app-form-validation-error',
    templateUrl: './form-validation-error.component.html',
    styleUrls: ['./form-validation-error.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: []
})
export class FormValidationErrorComponent {
  message = input('');
  showIcon = input(true);
  icon = input('exclamation-triangle');
  customClass = input('', { alias: 'class' });
}
